import _ from "lodash";
import {
  CLONE_AUDIENCE_SEGMENT_FAILED,
  CLONE_AUDIENCE_SEGMENT_REQUEST,
  CLONE_AUDIENCE_SEGMENT_SUCCEEDED,
  CLONE_CAMPAIGN_FAILED,
  CLONE_CAMPAIGN_REQUEST,
  CLONE_CAMPAIGN_SUCCEEDED,
  CREATE_AUDIENCE_SEGMENT_FAILED,
  CREATE_AUDIENCE_SEGMENT_REQUEST,
  CREATE_AUDIENCE_SEGMENT_SUCCEEDED,
  CREATE_CAMPAIGN_FAILED,
  CREATE_CAMPAIGN_REQUEST,
  CREATE_CAMPAIGN_SUCCEEDED,
  CREATE_PERSONALIZATION_LEAD_REQUEST,
  CREATE_PERSONALIZED_ALIAS_REQUEST,
  CREATING_PERSONALIZATION_LEAD_FAILED,
  CREATING_PERSONALIZATION_LEAD_SUCCEEDED,
  CREATING_PERSONALIZED_ALIAS_FAILED,
  CREATING_PERSONALIZED_ALIAS_SUCCEDED,
  DELETE_AUDIENCE_SEGMENT_FAILED,
  DELETE_AUDIENCE_SEGMENT_REQUEST,
  DELETE_AUDIENCE_SEGMENT_SUCCEEDED,
  DELETE_CAMPAIGN_FAILED,
  DELETE_CAMPAIGN_REQUEST,
  DELETE_CAMPAIGN_SUCCEEDED,
  DELETE_PAGE_ALIAS_REQUEST,
  DELETE_PERSONALIZATION_REQUEST,
  DELETING_PAGE_ALIAS_FAILED,
  DELETING_PAGE_ALIAS_SUCCEEDED,
  DELETING_PERSONALIZATION_FAILED,
  DELETING_PERSONALIZATION_SUCCEEDED,
  ENABLE_CAMPAIGN_FAILED,
  ENABLE_CAMPAIGN_REQUEST,
  ENABLE_CAMPAIGN_SUCCEEDED,
  FETCH_AUDIENCE_SEGMENT_FAILED,
  FETCH_AUDIENCE_SEGMENT_REQUEST,
  FETCH_AUDIENCE_SEGMENT_SUCCEEDED,
  FETCH_AUDIENCE_SEGMENTS_FAILED,
  FETCH_AUDIENCE_SEGMENTS_REQUEST,
  FETCH_AUDIENCE_SEGMENTS_SUCCEEDED,
  FETCH_CAMPAIGNS_FAILED,
  FETCH_CAMPAIGNS_REQUEST,
  FETCH_CAMPAIGNS_SEGMENTS_FAILED,
  FETCH_CAMPAIGNS_SEGMENTS_REQUEST,
  FETCH_CAMPAIGNS_SEGMENTS_SUCCEEDED,
  FETCH_CAMPAIGNS_SUCCEEDED,
  FETCHING_PERSONALISATION_FORM_FIELD_FAILED,
  FETCHING_PERSONALISATION_FORM_FIELD_REQUEST,
  FETCHING_PERSONALISATION_FORM_FIELD_SUCCEEDED,
  FETCHING_PERSONALIZATION_CONTACTS,
  FETCHING_PERSONALIZATION_CONTACTS_FAILED,
  FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED,
  FETCHING_PERSONALIZATION_LEADS_FAILED,
  FETCHING_PERSONALIZATION_LEADS_REQUEST,
  FETCHING_PERSONALIZATION_LEADS_SUCCEDED,
  FETCHING_PERSONALIZATION_LINKS_FAILED,
  FETCHING_PERSONALIZATION_LINKS_REQUEST,
  FETCHING_PERSONALIZATION_LINKS_SUCCEDED,
  INVALIDATE_AUDIENCE_SEGMENT_SELECTION,
  INVALIDATE_CAMPAIGN_SELECTION,
  INVALIDATE_CAMPAIGNS_AND_SEGMENTS,
  INVALIDATE_PERSONALIZATION,
  INVALIDATE_PERSONALIZATION_LEADS,
  SELECT_PERSONALIZATION_AUDIENCE_SEGMENT,
  SELECT_PERSONALIZATION_CAMPAIGN,
  UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST,
  UPDATE_AUDIENCE_SEGMENT_FAILED,
  UPDATE_AUDIENCE_SEGMENT_ORDER_FAILED,
  UPDATE_AUDIENCE_SEGMENT_ORDER_REQUEST,
  UPDATE_AUDIENCE_SEGMENT_ORDER_SUCCEEDED,
  UPDATE_AUDIENCE_SEGMENT_REQUEST,
  UPDATE_AUDIENCE_SEGMENT_SUCCEEDED,
  UPDATE_CAMPAIGN_FAILED,
  UPDATE_CAMPAIGN_REQUEST,
  UPDATE_CAMPAIGN_SUCCEEDED,
  UPDATE_PERSONALIZATION_ALIAS_REQUEST,
  UPDATE_PERSONALIZATION_REQUEST,
  UPDATING_PAGE_ALIAS_FAILED,
  UPDATING_PERSONALIZATION_ALIAS_FAILED,
  UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED,
  UPDATING_PERSONALIZATION_FAILED,
  UPDATING_PERSONALIZATION_SUCCEEDED,
  UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST,
  UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED,
  UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED,
} from "constants/actionTypes";

const initialState = {
  leads: {
    loading: false,
    fetched: false,
    error: null,
    invalidated: false,
    creating: false,
    update: {
      updating: false
    },
    deleting: false,
    items: [],
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
  },
  links: {
    loading: false,
    error: null,
    invalidated: false,
    creating: false,
    update: {
      updating: false
    },
    deleting: false,
    items:{},
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
  },
  contacts: {
    loading: false,
    fetched: false,
    error: null,
    invalidated: false,
    items: [],
    pagination: {
      current: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    },
  },
  formFields: {
    loading: false,
    items: [],
    pagination: {
      currentPage: -1,
      totalPages: 1
    },
    error: null
  },
  campaigns: {
    loading: false,
    updating: false,
    creating: false,
    deleting: false,
    items: [],
    selectedCampaign: null,
    pagination: {
      currentPage: 0,
      totalPages: 0,
      recordsPerPage: 0,
      totalRecordsCount: 0,
    },
    error: null,
  },
  segments: {
    loading: false,
    updating: false,
    creating: false,
    deleting: false,
    data: {},
    selectedSegment: null,
    error: null,
  },
  variables: {
    loading: false,
    items: [],
    error: null,
  },
  campaignsSegments: {
    loading: false,
    fetched: false,
    error: null,
    invalidated: false,
    items: [],
    pagination: {
      current: 0,
      totalPages: 0,
      recordsPerPage: 10,
      totalRecordsCount: 0,
    }
  }
};

export function personalizationReducer(state = initialState, action) {
  switch (action.type) {
    case FETCHING_PERSONALIZATION_LEADS_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          loading: true,
          fetched: false,
        },
      };
    }

    case FETCHING_PERSONALIZATION_LEADS_SUCCEDED: {
      const { response } = action.payload;
      let items = [];

      if (response.currentPage !== 0) {
        items = [...state.leads.items, ...response.records];
      } else {
        items = response.records;
      }
      
      items = _.uniqBy(items, 'id');

      return {
        ...state,
        leads: {
          ...state.leads,
          loading: false,
          fetched: true,
          items: items,
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
          },
        },
      };
    }

    case FETCHING_PERSONALIZATION_LEADS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        leads: {
          ...state.leads,
          loading: false,
          fetched: false,
          error: error,
        },
      };
    }

    case DELETE_PERSONALIZATION_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          deleting: true,
          deleted: false
        },
      };
    }

    case DELETING_PERSONALIZATION_SUCCEEDED: {
      const { id } = action.payload;

      const updatedLeads = state.leads.items.filter((lead) => lead.id !== id);

      return {
        ...state,
        leads: {
          ...state.leads,
          deleting: false,
          deleted: true,
          items: updatedLeads,
        },
      };
    }

    case DELETING_PERSONALIZATION_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        leads: {
          ...state.leads,
          deleting: false,
          error: error,
        },
      };
    }

    case CREATE_PERSONALIZATION_LEAD_REQUEST:
    case UPLOAD_LEADS_FOR_PERSONALIZATION_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          creating: true,
        },
      };
    }

    case CREATING_PERSONALIZATION_LEAD_SUCCEEDED:
    case UPLOADING_LEADS_FOR_PERSONALIZATION_SUCCEEDED: {

      if(action.payload.csvFile) {
        return state;
      }

      return {
        ...state,
        leads: {
          ...state.leads,
          creating: false,
          items: [],
        },
      };
    }

    case CREATING_PERSONALIZATION_LEAD_FAILED:
    case UPLOADING_LEADS_FOR_PERSONALIZATION_FAILED: {
      return {
        ...state,
        leads: {
          ...state.leads,
          creating: false,
          error: action.error
        },
      };
    }

    case UPDATE_PERSONALIZATION_REQUEST: {
      return {
        ...state,
        leads: {
          ...state.leads,
          update: {
            updating: true,
            success: false
          }
        },
      };
    }

    case UPDATING_PERSONALIZATION_SUCCEEDED: {
      const { response } = action.payload;

      const updatedLeads = state.leads.items.map((lead) => {
        if (lead.id === response.id) {
          return {
            ...lead,
            mappings: response.mappings,
          };
        }
        return lead; // keep others unchanged
      });


        return {
          ...state,
          leads: {
            ...state.leads,
            update: {
              updating: false,
              success: true
            },
            items: updatedLeads,
          },
        };
    }


    case UPDATING_PERSONALIZATION_FAILED:
      {

      const { error } = action.payload;

        return {
          ...state,
          leads: {
            ...state.leads,
            update: {
              updating: false,
              success: false,
              error: error
            }
          },
        };
      }

    case  UPDATE_PERSONALIZATION_ALIAS_REQUEST:
      {
        return {
          ...state,
          links: {
            ...state.links,
            update: {
              updating: true,
              success: false
            }
          },
        };
      }
    
    case UPDATING_PERSONALIZATION_ALIAS_SUCCEEDED: 
      const {lead, id, response } = action.payload;

      const updatedLinks = state.links.items[lead] || [];
      const updatedLink = updatedLinks.map((link) => {
        if (link.id === id) {
          return {
            ...link,
            url: response.url,
          };
        }
        return link; // keep others unchanged
      });

      {
        return {
          ...state,
          links: {
            ...state.links,
            update: {
              updating: false,
              success: true
            },
            items: {
              ...state.links.items,
              [lead]: updatedLink,
            },
          },
        };
      }

    case UPDATING_PERSONALIZATION_ALIAS_FAILED:
      {
      const { errors } = action.payload;

        return {
          ...state,
          links: {
            ...state.links,
            update: {
              success: false,
              updating: false,
              error: errors
            },
          },
        };
      }

    case CREATE_PERSONALIZED_ALIAS_REQUEST: 
    {
      return {
        ...state,
        links: {
          ...state.links,
          creating: true,
        },
      };
    }

    case CREATING_PERSONALIZED_ALIAS_SUCCEDED:     
    {
      const {response} = action.payload;
      const existingArray = state.links.items[response.personalization] || [];
      const updatedArray = [response, ...existingArray]; 

      return {
        ...state,
        links: {
          ...state.links,
          creating: false,
          items: {
            ...state.links.items,
            [response.personalization]: updatedArray
          }
        },
      };
    }

    case CREATING_PERSONALIZED_ALIAS_FAILED: {
      const { error } = action.payload;
      return {
        ...state,
        links: {
          ...state.links,
          creating: false,
          error: error
        },
      };
    }

    case FETCHING_PERSONALIZATION_LINKS_REQUEST: {

      return {
        ...state,
        links: {
          ...state.links,
          loading: true
        },
      };
    }

    case DELETE_PAGE_ALIAS_REQUEST: {
      return {
        ...state,
        links: {
          ...state.links,
          deleting: true
        },
      };
    }

    case DELETING_PAGE_ALIAS_SUCCEEDED: {
      const {id, request } = action.payload;
      const existingArray = state.links.items[request.personalization] || [];

      return {
        ...state,
        links: {
          ...state.links,
          deleting: false,
          items:{
            ...state.links.items,
            [request.personalization]: existingArray.filter(
              (item) => item.id !== id
            ),
          }
        }
      };
    }

    case DELETING_PAGE_ALIAS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        links: {
          ...state.links,
          deleting: false,
          error: error
        },
      };
    }

    case FETCHING_PERSONALIZATION_LINKS_SUCCEDED: {
      const { id, response } = action.payload;
      const existingLinks = _.get(state, `links.items.${id}`, []);
    
      let items = [];
      if (response.currentPage !== 0) {
        items = [...existingLinks, ...response.records];
      } else {
        items = response.records;
      }
    
      items = _.uniqBy(items, 'id');
    
      return {
        ...state,
        links: {
          ...state.links,
          loading: false,
          items: {
            ...state.links.items,
            [id]: items,
          },
          pagination: {
            currentPage: response.currentPage,
            totalPages: response.totalPages,
            recordsPerPage: response.recordsPerPage,
            totalRecordsCount: response.totalRecordsCount,
          },
        },
      };
    }    

    case FETCHING_PERSONALIZATION_LINKS_FAILED: {
      const { error } = action.payload;

      return {
        ...state,
        links: {
          ...state.links,
          loading: false,
          error: error
        }
      };
    }

    case FETCHING_PERSONALIZATION_CONTACTS: {

      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: true,
          error: null,
        },
      };
    }
    
    case FETCHING_PERSONALIZATION_CONTACTS_SUCCEEDED: {
      const { response } = action.payload;
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: false,
          fetched: true,
          error: null,
          items: response?.records || [],
          pagination: {
            current: response?.currentPage || 0,
            totalPages: response?.totalPages || 0,
            recordsPerPage: response?.recordsPerPage || 10,
            totalRecordsCount: response?.totalRecordsCount || 0,
          }
        },
      };
    }
    
    case FETCHING_PERSONALIZATION_CONTACTS_FAILED: {
      return {
        ...state,
        contacts: {
          ...state.contacts,
          loading: false,
          error: action.payload.error,
        },
      };
    }

    case FETCHING_PERSONALISATION_FORM_FIELD_REQUEST: {
      return {
        ...state,
        formFields: {
          ...state.formFields,
          loading: true
        }
      }
    }    

    case FETCHING_PERSONALISATION_FORM_FIELD_SUCCEEDED: {
      const { records, currentPage, recordsPerPage, totalPages, totalRecordsCount } = action.payload;
      let items = records || [];
      if (currentPage !== 0) {
        items = [...state.formFields.items, ...records];
      } else {
        items = records
      }

      return {
        ...state,
        formFields: {
          ...state.formFields,
          loading: false,
          items: items,
          pagination: {
            ...state.formFields.pagination,
            currentPage,
            totalPages,
            recordsPerPage,
            totalRecordsCount
          }
        }
      }
    }

    case FETCHING_PERSONALISATION_FORM_FIELD_FAILED: {
      var error = action.payload;
    
      return {
        ...state,
        formFields: {
          ...state.formFields,
          loading: false,
          invalidated: false,
          error: error
        }
      }
    }

    case INVALIDATE_PERSONALIZATION_LEADS: {
      const { type } = action.payload;


      return {
        ...state,
        [type]: {
          ...state[type],
          update: {
            updating: false,
          }
        }
      };
    }

    
  // Fetch All Campaigns
  case FETCH_CAMPAIGNS_REQUEST: {
    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        loading: true,
      },
    };
  }

  case FETCH_CAMPAIGNS_SUCCEEDED: {
    const { response } = action.payload;
    let items = [];

    if (response.currentPage !== 0) {
      items = [...state.campaigns.items, ...response.records];
    } else {
      items = response.records;
    }

    items = _.uniqBy(items, "id");

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        loading: false,
        items: items,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          recordsPerPage: response.recordsPerPage,
          totalRecordsCount: response.totalRecordsCount,
        },
      },
    };
  }

  case FETCH_CAMPAIGNS_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        loading: false,
        error: error,
      },
    };
  }

  // Create Campaign
  case CREATE_CAMPAIGN_REQUEST: {
    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        creating: true,
      },
    };
  }

  case CREATE_CAMPAIGN_SUCCEEDED: {
    const { response } = action.payload;

    const existingArray = state.campaigns.items || [];
    const updatedArray = [response, ...existingArray];

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        creating: false,
        items: updatedArray,
      },
    };
  }

  case CREATE_CAMPAIGN_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        creating: false,
        error: error,
      },
    };
  }

  // Update Campaign
  case UPDATE_CAMPAIGN_REQUEST: {
    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        updating: true,
      },
    };
  }

  case UPDATE_CAMPAIGN_SUCCEEDED: {
    const { response } = action.payload;

    const updatedItems = state.campaigns.items.map((item) => {
      if (item.id === response.id) {
        return {
          ...item,
          enabled: response.enabled,
          name: response.name,
        };
      }
      return { ...item, enabled: response.enabled ? false : item.enabled }; // keep others unchanged
    });

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        updating: false,
        items: updatedItems,
      },
    };
  }

  case UPDATE_CAMPAIGN_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        updating: false,
        error: error,
      },
    };
  }

  // Enable Campaign
  case ENABLE_CAMPAIGN_REQUEST: {
    return {
      ...state,
      campaigns: {
        ...state.campaigns,
      },
    };
  }

  case ENABLE_CAMPAIGN_SUCCEEDED: {
    const { response } = action.payload;

    const updatedItems = state.campaigns.items.map((item) =>
      item.id === response.id
        ? { ...item, enabled: response.enabled }
        : { ...item, enabled: false }
    );

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        items: updatedItems,
      },
    };
  }

  case ENABLE_CAMPAIGN_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        error: error,
      },
    };
  }

  // Clone Campaign
  case CLONE_CAMPAIGN_REQUEST: {
    return {
      ...state,
      campaigns: {
        ...state.campaigns,
      },
    };
  }

  case CLONE_CAMPAIGN_SUCCEEDED: {
    const { response } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        items: [response, ...state.campaigns.items],
      },
    };
  }

  case CLONE_CAMPAIGN_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        error: error,
      },
    };
  }

  // Delete Campaign
  case DELETE_CAMPAIGN_REQUEST: {
    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        deleting: true,
      },
    };
  }

  case DELETE_CAMPAIGN_SUCCEEDED: {
    const { response } = action.payload;

    const filteredItems = state.campaigns.items.filter(
      (item) => item.id !== response.id
    );

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        deleting: false,
        items: filteredItems,
      },
    };
  }

  case DELETE_CAMPAIGN_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        deleting: false,
        error: error,
      },
    };
  }

  // Fetch All Audience Segments
  case FETCH_AUDIENCE_SEGMENTS_REQUEST: {
    const { request } = action.payload;

    if (!request.campaign) {
      return {
        ...state,
        segments: {
          ...state.segments,
          loading: true,
        }
      };
    }

    return {
      ...state,
      segments: {
        ...state.segments,
        loading: true,
        data: {
          ...state.segments.data,
          [request.campaign]: {
            items: [],
            pagination: {
              currentPage: 0,
              totalPages: 0,
              recordsPerPage: 10,
              totalRecordsCount: 0,
            },
          },
        },
      },
    };
  }

  case FETCH_AUDIENCE_SEGMENTS_SUCCEEDED: {
    const { response, campaignId } = action.payload;

    const existingSegments = state.segments.data?.[campaignId] || [];
    let items = [];

    if (response.currentPage !== 0) {
      items = [...existingSegments?.items, ...response.records];
    } else {
      items = response.records;
    }

    items = _.uniqBy(items, "id");

    return {
      ...state,
      segments: {
        ...state.segments,
        loading: false,
        data: {
          ...state.segments.data,
          [campaignId]: {
            items: items,
            pagination: {
              currentPage: response.currentPage,
              totalPages: response.totalPages,
              recordsPerPage: response.recordsPerPage,
              totalRecordsCount: response.totalRecordsCount,
            },
          },
        },
      },
    };
  }

  case FETCH_AUDIENCE_SEGMENTS_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        loading: false,
        error: error,
      },
    };
  }

  // Fetch Single Audience Segment
  case FETCH_AUDIENCE_SEGMENT_REQUEST: {
    return {
      ...state,
      segments: {
        ...state.segments,
        fetching: true,
      }
    };
  }

  case FETCH_AUDIENCE_SEGMENT_SUCCEEDED: {
    const { response } = action.payload;

    const updatedItems = (state.segments.data[response.campaign]?.items || []).map((item) =>
      item.id === response.id ? response : item
    );
  
    return {
      ...state,
      segments: {
        ...state.segments,
        fetching: false,
        data: {
          ...state.segments.data,
          [response.campaign]: {
            ...(state.segments.data?.[response.campaign] || {}),
            items: updatedItems,
          },
        },
      },
    };
  }


   // Clone Campaign
  case CLONE_AUDIENCE_SEGMENT_REQUEST: {
    return {
      ...state,
      segments: {
        ...state.segments,
      },
    };
  }

  case CLONE_AUDIENCE_SEGMENT_SUCCEEDED: {
    const { response } = action.payload;
    const campaignId = response.campaign; // or wherever the campaignId is in response

    const existingSegments = state.segments.data?.[campaignId] || [];

    return {
      ...state,
      segments: {
        ...state.segments,
        creating: false,
        data: {
          ...state.segments.data,
          [campaignId]: {
            ...existingSegments,
            items: [ ...existingSegments.items, response],
          },
        },
      },
    };
  }

  case CLONE_AUDIENCE_SEGMENT_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        error: error,
      },
    };
  }
  

  case FETCH_AUDIENCE_SEGMENT_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        fetching: false,
        error: error,
      }
    };
  }

  // Create Audience Segment
  case CREATE_AUDIENCE_SEGMENT_REQUEST: {
    return {
      ...state,
      segments: {
        ...state.segments,
        creating: true,
      },
    };
  }

  case CREATE_AUDIENCE_SEGMENT_SUCCEEDED: {
    const { response } = action.payload;
    const campaignId = response.campaign; // or wherever the campaignId is in response

    const existingSegments = state.segments.data?.[campaignId] || [];

    return {
      ...state,
      segments: {
        ...state.segments,
        creating: false,
        data: {
          ...state.segments.data,
          [campaignId]: {
            ...existingSegments,
            items: [...existingSegments.items, response],
          },
        },
      },
    };
  }

  case CREATE_AUDIENCE_SEGMENT_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        creating: false,
        error: error,
      },
    };
  }

  case SELECT_PERSONALIZATION_CAMPAIGN: {
    const { campaign } = action.payload;

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        selectedCampaign: campaign,
      },
    };
  }

  case SELECT_PERSONALIZATION_AUDIENCE_SEGMENT: {
    const { segment } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        selectedSegment: segment,
      }
    };
  }

  // Update Audience Segment
  case UPDATE_AUDIENCE_SEGMENT_REQUEST: {
    return {
      ...state,
      segments: {
        ...state.segments,
        updating: true,
      },
    };
  }

  case UPDATE_AUDIENCE_SEGMENT_SUCCEEDED: {
    const { response } = action.payload;

    const updatedItems = (state.segments.data[response.campaign]?.items || []).map((item) =>
      item.id === response.id ? response : item
    );

    return {
      ...state,
      segments: {
        ...state.segments,
        updating: false,
        data: {
          ...state.segments.data,
          [response.campaign]: {
            ...(state.segments.data[response.campaign] || {}),
            items: updatedItems,
          },
        },
      },
    };
  }

  case UPDATE_AUDIENCE_SEGMENT_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        updating: false,
        error: error,
      },
    };
  }

  // Update Order
  case UPDATE_AUDIENCE_SEGMENT_ORDER_REQUEST: {
    return {
      ...state,
      segments: {
        ...state.segments,
      },
    };
  }

  case UPDATE_AUDIENCE_SEGMENT_ORDER_SUCCEEDED: {
    const { response, campaign } = action.payload;
    const updatedOrders = response.records;
    const currentItems = (state.segments.data[campaign]?.items || []);
    const orderMap = updatedOrders.reduce((acc, { id, order }) => {
      acc[id] = order;
      return acc;
    }, {});
  
    // Step 2: Update each item with new order (if available)
    const updatedItems = currentItems.map(item => ({
      ...item,
      order: orderMap[item.id] ?? item.order,
    }));
  
    // Step 3: Sort by order ASC
    const sortedItems = _.sortBy(updatedItems, 'order');

    return {
      ...state,
      segments: {
        ...state.segments,
        updating: false,
        data: {
          ...state.segments.data,
          [campaign]: {
            ...(state.segments.data[campaign] || {}),
            items: sortedItems,
          },
        },
      },
    };
  }

  case UPDATE_AUDIENCE_SEGMENT_ORDER_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        updating: false,
        error: error,
      },
    };
  }

  case UPDATE_AND_REORDER_AUDIENCE_SEGMENT_REQUEST: {
    const { updateRequest, orderRequest, callback } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        updating: true,
      },
    };
  }

  case DELETE_AUDIENCE_SEGMENT_REQUEST: {
    return {
      ...state,
      segments: {
        ...state.segments,
        deleting: true,
      },
    };
  }

  case DELETE_AUDIENCE_SEGMENT_SUCCEEDED: {
    const { request } = action.payload;
    const { campaign, segment } = request;

    const filteredItems = (state.segments.data[campaign]?.items || []).filter(
      (item) => item.id !== segment
    );

    return {
      ...state,
      segments: {
        ...state.segments,
        deleting: false,
        data: {
          ...state.segments.data,
          [campaign]: {
            ...(state.segments.data[campaign] || {}),
            items: filteredItems,
          },
        },
      },
    };
  }

  case DELETE_AUDIENCE_SEGMENT_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      segments: {
        ...state.segments,
        deleting: false,
        error: error,
      },
    };
  }

  case FETCH_CAMPAIGNS_SEGMENTS_REQUEST: {
    return {
      ...state,
      campaignsSegments: {
        ...state.campaignsSegments,
        loading: true,
      }
    };
  }

  case FETCH_CAMPAIGNS_SEGMENTS_SUCCEEDED: {
    const { response } = action.payload;
    let items = [];

    if (response.currentPage !== 0) {
      items = [...state.campaignsSegments.items, ...response.records];
    } else {
      items = response.records;
    }

    items = _.uniqBy(items, "id");

    return {
      ...state,
      campaignsSegments: {
        ...state.campaignsSegments,
        loading: false,
        items: items,
        pagination: {
          currentPage: response.currentPage,
          totalPages: response.totalPages,
          recordsPerPage: response.recordsPerPage,
          totalRecordsCount: response.totalRecordsCount,
        },
      },
    };
  }

  case FETCH_CAMPAIGNS_SEGMENTS_FAILED: {
    const { error } = action.payload;

    return {
      ...state,
      campaignsSegments: {
        ...state.campaignsSegments,
        loading: false,
        error: error
      },
    };
  }

  case INVALIDATE_PERSONALIZATION_LEADS: {
    const { type } = action.payload;

    return {
      ...state,
      [type]: {
        ...state[type],
        update: {
          updating: false,
        },
      },
    };
  }

  case INVALIDATE_AUDIENCE_SEGMENT_SELECTION: {

    return {
      ...state,
      segments: {
        ...state.segments,
        selectedSegment: null,
      },
    }
  }

  case INVALIDATE_CAMPAIGN_SELECTION: {

    return {
      ...state,
      campaigns: {
        ...state.campaigns,
        selectedCampaign: null,
      },
    };
  }


  case INVALIDATE_CAMPAIGNS_AND_SEGMENTS: {
    return {
      ...state,
      campaigns: {
        loading: false,
        updating: false,
        creating: false,
        deleting: false,
        items: [],
        selectedCampaign: null,
        pagination: {
          currentPage: 0,
          totalPages: 0,
          recordsPerPage: 0,
          totalRecordsCount: 0,
        },
        error: null,
      },
      segments: {
        loading: false,
        updating: false,
        creating: false,
        deleting: false,
        data: {},
        selectedSegment: null,
        error: null,
      }
    };
  }

  case INVALIDATE_PERSONALIZATION: {
    return initialState;
  }
    default:
      return state;
  }
}
